// Lib
import React, { ReactElement } from 'react';

// Components
import MobileTextStyleRichTextSheet from './MobileTextStyleRichTextSheet';
import MobileTableTextStyleSheetContent from './MobileTableTextStyleSheetContent';

// Types
import type { MobileTextStyleRichTextSheetProps } from './MobileTextStyleRichTextSheet';

/**
 * Renders the mobile text style tool for selected table cells.
 */
const MobileTableTextStyleRichTextTool: React.FC<MobileTextStyleRichTextSheetProps> = (props): ReactElement => {
    return <MobileTextStyleRichTextSheet {...props} SheetContentComponent={MobileTableTextStyleSheetContent} />;
};

export default MobileTableTextStyleRichTextTool;
